export default __webpack_public_path__ + "static/taxi-ef802f35f5b1ec2f7a1e30dc6bf200bf.png";